const STORAGE_KEY = 'koketa:wishlist:v1';

const readWishlist = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
};

const writeWishlist = (items) => localStorage.setItem(STORAGE_KEY, JSON.stringify(items));

const refreshWishlistFromPage = (items) => {
  const visibleProducts = new Map(
    [...document.querySelectorAll('[data-koketa-favorite][data-handle]')].map((button) => [
      button.dataset.handle,
      {
        title: button.dataset.title,
        url: button.dataset.url,
        image: button.dataset.image,
        price: button.dataset.price,
      },
    ])
  );
  let changed = false;
  const refreshed = items.map((item) => {
    const visible = visibleProducts.get(item.handle);
    if (!visible) return item;
    const next = { ...item, ...visible };
    if (Object.keys(visible).some((key) => next[key] !== item[key])) changed = true;
    return next;
  });
  if (changed) writeWishlist(refreshed);
  return refreshed;
};

const escapeHtml = (value) =>
  String(value).replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    "'": '&#39;',
    '"': '&quot;',
  })[character]);

const renderWishlist = () => {
  const items = refreshWishlistFromPage(readWishlist());
  const dialog = document.querySelector('#KoketaWishlist');
  const addLabel = dialog?.dataset.addLabel || 'Save to favourites';
  const removeLabel = dialog?.dataset.removeLabel || 'Remove from favourites';
  const removeTemplate = dialog?.dataset.removeTemplate || 'Remove __TITLE__ from favourites';
  document.querySelectorAll('[data-koketa-wishlist-count]').forEach((count) => {
    count.textContent = items.length;
    count.hidden = items.length === 0;
  });

  document.querySelectorAll('[data-koketa-favorite]').forEach((button) => {
    const selected = items.some((item) => item.handle === button.dataset.handle);
    button.setAttribute('aria-pressed', String(selected));
    button.classList.toggle('is-selected', selected);
    const action = selected ? removeLabel : addLabel;
    button.setAttribute('title', action);
  });

  const list = document.querySelector('[data-koketa-wishlist-list]');
  const empty = document.querySelector('[data-koketa-wishlist-empty]');
  if (!list || !empty) return;

  empty.hidden = items.length > 0;
  list.innerHTML = items.map((item) => `
    <article class="koketa-wishlist__item">
      <a href="${escapeHtml(item.url)}">
        ${item.image ? `<img src="${escapeHtml(item.image)}" alt="" width="160" height="200" loading="lazy">` : ''}
        <span><strong>${escapeHtml(item.title)}</strong><small>${escapeHtml(item.price)}</small></span>
      </a>
      <button type="button" data-koketa-wishlist-remove="${escapeHtml(item.handle)}" aria-label="${escapeHtml(removeTemplate.replace('__TITLE__', item.title))}">×</button>
    </article>
  `).join('');
};

document.addEventListener('click', (event) => {
  const openButton = event.target.closest('[data-koketa-wishlist-open]');
  const closeButton = event.target.closest('[data-koketa-wishlist-close]');
  const favoriteButton = event.target.closest('[data-koketa-favorite]');
  const removeButton = event.target.closest('[data-koketa-wishlist-remove]');
  const dialog = document.querySelector('#KoketaWishlist');

  if (openButton && dialog) {
    renderWishlist();
    dialog.showModal();
  }

  if (closeButton && dialog) dialog.close();

  if (favoriteButton) {
    const items = readWishlist();
    const index = items.findIndex((item) => item.handle === favoriteButton.dataset.handle);
    if (index >= 0) items.splice(index, 1);
    else items.push({
      handle: favoriteButton.dataset.handle,
      title: favoriteButton.dataset.title,
      url: favoriteButton.dataset.url,
      image: favoriteButton.dataset.image,
      price: favoriteButton.dataset.price,
    });
    writeWishlist(items);
    renderWishlist();
  }

  if (removeButton) {
    writeWishlist(readWishlist().filter((item) => item.handle !== removeButton.dataset.koketaWishlistRemove));
    renderWishlist();
  }
});

document.addEventListener('DOMContentLoaded', renderWishlist);
document.addEventListener('shopify:section:load', renderWishlist);
